import step2img from '../../../../assets/images/return/step2.png';
import { useTranslate } from '../../../../hooks/useTranslate';

import {
  ContentWrapper,
  Heading,
  Image,
  ListItem,
  OrderedList,
} from '../../styled';

export default function Packaging(): JSX.Element {
  const { staticTranslate } = useTranslate();

  return (
    <>
      <Image src={step2img} />
      <ContentWrapper>
        <Heading>{staticTranslate('theShipmentMustBe')}</Heading>
        <OrderedList>
          <ListItem>{staticTranslate('packTheProductInABoxOrBag')}</ListItem>
          <ListItem>{staticTranslate('tapeThePackagingSo')}</ListItem>
        </OrderedList>
      </ContentWrapper>
    </>
  );
}
